<template>
    <a-layout>
      <checkout-header />
      <a-layout-content>
        <router-view></router-view>
      </a-layout-content>
      <app-footer />
    </a-layout>
    
  </template>
  
  <script>
  // @ is an alias to /src
  import CheckoutHeader from "./components/CheckoutHeader";
  import AppFooter from './components/AppFooter.vue'
  export default {
    name: "default",
    components: {
      CheckoutHeader,
      AppFooter
    },
    data() {
      return {};
    }
  };
  </script>
  
  <style lang="scss">
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
  }
  </style>
  